<template>
  <div>
    <b class="post-title">{{post.title}}</b>
    <div class="post-body">
      <div class="post-body__text" v-html="trimHref"></div>
    </div>
    <div class="post-info-panel">
      <div></div>
      <div class="post-info-panel__item" v-if="showMoreButton(post)">
        <span v-if="!showMore" @click="showMoreHandle(true)">{{$t('post.postInfoPanel.more')}}</span>
        <span class="post-info-panel__item" v-if="showMore" @click="showMoreHandle(false)">Скрыть</span>
      </div>
    </div>
  </div>
</template>

<script>
  // components
  import Trust from './Trust';

  export default {
    name: 'PostBody',
    props: {
      post: {
        type: Object
      },
      // showMore: {
      //   type: Boolean
      // },
      isRepost: {
        type: Boolean
      },
    },
    data() {
      return {
        showMore: false,
        trimTextLength: 400,
        regex: /\[(.*?)\]/g,
        social: {
          vk: {
            domen: 'https://vk.com/',
          },
          fb: {
            domen: 'https://www.facebook.com/',
          },
          tw: {
            domen: 'https://twitter.com/',
          },
        },
      };
    },
    computed: {
      trimHref() {
        this.replaceByNetwork();
        return this.trimmedText;
      },
      trimmedText() {
        if (this.showMore) {
          return this.post.text;
        }

        if (this.trimTextLength > this.post.text.length) {
          return this.post.text;
        }

        return `${this.post.text.substring(0, this.trimTextLength)} ...`;
      },
    },
    methods: {
      getTrust(post) {
        if (!post.trust.trust) {
          return 0;
        } else {
          return Number(post.trust.trust);
        }
      },
      showMoreHandle(val) {
        this.showMore = val;
      },
      showMoreButton() {
        return this.post.text.length > this.trimTextLength;
      },
      setTrust (trust) {
        this.$emit('setTrust', {postId: this.post.id, trust});
      },
      replaceByNetwork() {
        const matches = this.post.text.match(this.regex);
        if(this.social[this.post.network_name]) {
          if (matches) {
            const matchedValues = matches.map(match => match.replace('[', this.social[this.post.network_name].domen).replace(']', '')).join(' ');
            const matchedArray = matchedValues.split('|');
            const link = `<a href="${matchedArray[0]}" target="_blank">${matchedArray[1]}</a>`;
            this.post.text = this.post.text.replace(matches[0], link);
          }
        }
      },
    },
    components: {
      Trust,
    },
  };
</script>

<style>
  .post-body {
    display: flex;
    min-height: 90px;
  }
  .post-body__additional {
    position: absolute;
    margin-top: -10px;
  }

  .post-body__text {
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 300;
    line-height: 1.4;
    word-break: break-word;
  }
  .post-body__text * {
    width: 100%;
  }
  .post-body__divider {
    margin-bottom: 20px;
  }
  .post-title{
    color: #409EFF;
    margin-bottom: 10px;
    display: block;
  }
</style>
